import servicesUtils from "../../../utils/servicesUtils";
var getLinkedFhirResources = function getLinkedFhirResources(workspaceId, patientId, resourceType, resourceIds) {
  return servicesUtils.postService("emr/workspaces/".concat(workspaceId, "/patients/").concat(patientId, "/resources/").concat(resourceType, "/"), {
    resource_ids: resourceIds
  });
};
export default getLinkedFhirResources;